import _c from "../CodeSkeleton/CodeSkeleton.module.css";
import React, {Fragment} from "react";

const JavascriptTopShell = () => {
    return <Fragment>
                    <span><span className={_c.highlight}>window</span>.<span className={_c.gold}>addEventListener</span>(<span
                        className={_c.text}>'DOMContentLoaded'</span>, <span
                        className={_c.orange}>function</span>(){"{"}</span>
        <span className={_c.indent1}><span className={_c.orange}>var</span> {"pieJson = {"}</span></Fragment>
};

export default JavascriptTopShell;